/**
 * Pricing utilities — fully slimmed in Phase I3 + I4. The original
 * file held the smart-pricing engine that powered EditListingCustom-
 * PricingPanel + EditListingPackageDetailsForm; both are gone, so
 * the cost-database lookup helpers (findMatchingItem, estimateItem-
 * Cost, calculatePackageValue) and their item-costs.json data file
 * went with them.
 *
 * What's left: a single helper used by TierSelector to render the
 * per-tier price preview when the listing has both a base and
 * per-guest rate. No listings currently write that shape, but
 * TierSelector still calls this defensively.
 */

/**
 * Calculate total price from base and per-guest components.
 * Returns price in subunits (cents).
 */
export const calculateTotalPrice = (basePricePerDay, perGuestPricePerDay, guestCount) => {
  return basePricePerDay + (perGuestPricePerDay * guestCount);
};
